import { getReportParams, report } from '../../../../middleware/report';
import {
} from '../Constant/Constant';

export const DWHStatus = {
  Ongoing: 'Ongoing',
  Completed: 'Completed',
  Error: 'Error',
}

export const DwhActionType = {
  ChoosePackagePage: 'Choose package Page',
  ChooseBanPage: 'Choose Ban page',
  SelectLineAddressPage: 'Select Line/Address Page',
  DetailPage: 'Detail page',
  AddressPage: 'Address page',
  PaymentMethodPage: 'Payment Method page',
  SuccessScreen: 'Success Screen',
  ErrorScreen: 'Error Screen'
}

export const selectedProductType = {
  Cellular: 'נייד',
  Internet: 'אינטרנט',
  TV: 'TV',
  Bundle: ''
}
export const DWHMessageText = {
  GeneralError: 'General Error ',
  ChoosePackagePageDisplayed: 'Choose package Page Displayed',
  ChoosePackagePageButtonClicked: 'Choose package Page Button Clicked',
  ChooseBanPageDisplayed: 'Choose Ban page Displayed',
  ChooseBanPageButtonClicked: 'Choose Ban page Button Clicked',
  ErrorOpenOrderDisplayed: 'Error Open Order Displayed',
  ErrorUserBNIYODDisplayed: 'Error User BNIYOD Displayed',
  ErrorUserIsAbroadDisplayed: 'Error User is abroad Displayed',
  ErroreSIMDisplayed: 'Error eSIM Displayed',
  ErrorUserPostponedDisplayed: 'Error User postponed Displayed',
  ErrorDataUserDisplayed: 'Error Data User Displayed',
  ErrorBusinessUserDisplayed: 'Error Business User Displayed',
  DetailPageDisplayed: 'Detail page Displayed',
  DetailPageButtonClicked: 'Detail page Button Clicked',
  AddressPageDisplayed: 'Address page Displayed',
  AddressPageButtonClicked: 'Address page Button Clicked',
  PaymentMethodPageDisplayed: 'Payment Method page Displayed',
  PaymentMethodPageButtonClicked: 'Payment Method page Button Clicked',
  SuccessScreenCellularInternet: 'Success Screen - Cellular/internet',
  SuccessScreenTV: 'Success Screen - TV'
}



export function dwhGeneralReport({ data, actionType, messageText, status }) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'OwnershipTransfer - buyer';
  reportParams.channel = 'WebsitePrivate';
  reportParams.actionType = actionType;
  reportParams.status = status;
  reportParams.messageText = messageText;
  reportParams.param1 = data.serviceType == 'Cellular' ? 'נייד' : data.userDetails?.magicLinkParameters?.productType;
  reportParams.param2 = data.serviceType == 'Cellular' ? data.transferSubscriberNumber : "";
  reportParams.param3 = data.userDetails?.magicLinkParameters?.subscriberExternalId;
  reportParams.param4 = data.userDetails?.magicLinkParameters?.idNumber;
  reportParams.param5 = data.userDetails?.magicLinkParameters?.otpPhone;
  reportParams.param9 = data.userDetails?.userDetails?.IsContactPerson ? 'איש קשר' : 'מנוי';
  reportParams.param10 = 'מגיק לינק';
  reportParams.idNumber = data.userDetails?.magicLinkParameters?.idNumber;
  reportParams.sourceURL = window.location.href;
  reportParams.customerName = `${data.userDetails?.magicLinkParameters?.firstName} ${data.userDetails?.magicLinkParameters?.lastName}`;
  reportParams.subscriber = data.userDetails?.otpPhone;

  report(reportParams);
}
